import client from './index';

export default {
  async getStickers() {
    const res = await client.get('v1/diamond-item/get-stickers');
    return res.data;
  },
};
